import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { UserService } from '../shared/services/user.service';
import { Message } from 'primeng/primeng';
import { CommonDataService } from '../shared/services/common-data.service';

@Component({
    selector: 'app-confirmpassword',
    templateUrl: './confirmpassword.component.html',
    styleUrls: ['./confirmpassword.component.css']
})
export class ConfirmpasswordComponent implements OnInit {

    id;
    token;
    changePasswordData: FormGroup;
    msg: Message[];
    submitted: boolean = false;
    quantidadecharacteres:string="";
    quantidadecharacteresrenewpassword:string="";

  
    styleforcapassword:string="empty"

    constructor(private commonDataService: CommonDataService, private userService: UserService, private router: Router, private activatedRoute: ActivatedRoute) {


    }

    ngOnInit() {
        this.id = this.activatedRoute.snapshot.queryParams['id'];
        this.token = this.activatedRoute.snapshot.queryParams['token'];
        this.formControls();
    }

    formControls() {
        this.changePasswordData = new FormGroup({
            'newPassword': new FormControl('', Validators.required),
            'rePassword': new FormControl('', Validators.required),
        });
    }

    onChangeValorNewPassword(event){
        if( event.currentTarget.value){
            if(event.currentTarget.value.length > 0){
                this.quantidadecharacteres = event.currentTarget.value.length+' characters';
            }else{
                this.quantidadecharacteres = '';
            }
        }else{
            this.quantidadecharacteres = '';
        }
    }

    
  onChangeValorPassword(event){
    if(event.currentTarget.value){
      this.styleforcapassword = this.checkForcePassword(event.currentTarget.value);
    }else{
      this.styleforcapassword = 'empty'
    }
  }



checkForcePassword(passord) 
{
	var numeros = /([0-9])/;
	var alfabeto = /([a-zA-Z])/;
	var chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;

	if(passord.length<6) 
	{
		return 'weak';
	} else {  	
		if(passord.match(numeros) && passord.match(alfabeto) && passord.match(chEspeciais))
		{            
			return 'strong'
		} else {
			return 'medium'
		}
	}
}



    onChangeValorReNewPassword(event){
        if( event.currentTarget.value){
            if(event.currentTarget.value.length > 0){
                this.quantidadecharacteresrenewpassword = event.currentTarget.value.length+' characters';
            }else{
                this.quantidadecharacteresrenewpassword = '';
            }
        }else{
            this.quantidadecharacteresrenewpassword = '';
        }
    }


    onSubmit() {
        this.msg = [];
        this.submitted = true;
        let userData = this.changePasswordData.value;

            this.userService.resetPasswordFundraiser(userData, this.id, this.token)
                .subscribe(
                data => {
                    this.router.navigate(['/confirmpasswordsuccess']);   
              
                },
                error => {
                    if(error.parameterErrors != undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({ severity: 'error', detail: error.parameterErrors[i].message });
                        }
                    } else if(error.message.length != 0) {
                        this.msg.push({ severity: 'error', detail: error.message });
                    }
                }
            );
        

    }

}



// WEBPACK FOOTER //
// ./src/app/confirmpassword/confirmpassword.component.ts